import { render, staticRenderFns } from "./RollingShutterDescription.vue?vue&type=template&id=639cb331&scoped=true"
import script from "./RollingShutterDescription.vue?vue&type=script&lang=ts"
export * from "./RollingShutterDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639cb331",
  null
  
)

export default component.exports